import { useLocation, Link } from 'react-router-dom'
import { useEffect } from 'react'
import { Card } from '@/components/ui/card'

const NotFound = () => {
  const location = useLocation()

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname)
  }, [location.pathname])

  return (
    <div className="min-h-[80vh] flex items-center justify-center">
      <Card variant="dark" className="text-center max-w-md mx-auto p-6">
        <h1 className="text-6xl font-bold text-[#C0FD72] mb-4">404</h1>
        <p className="text-xl text-white mb-6">Oops! Page not found</p>
        <p className="text-gray-400 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="px-4 py-2 bg-[#C0FD72] text-black rounded-md hover:bg-[#d2ff9c] inline-block"
        >
          Return to Dashboard
        </Link>
      </Card>
    </div>
  )
}

export default NotFound
